<template>
<div>
</div>
</template>

<script>
import { useClient, useMutation } from 'villus';
import { gql } from 'graphql-tag';
import { computed, reactive } from 'vue';
import { useStore } from 'vuex';

export default {
  name: 'updateUserDataPolicyMutation',

  setup() {
    const store = useStore();

    useClient({
      url: process.env.VUE_APP_STRAPI,
    });

    const updateUserDataPolicyMutation = gql`
      mutation($userDataId: ID!, $version: String!) {
        updateUserData(id: $userDataId, data: { datenschutzVersion: $version }) {
          data {
            attributes {
              datenschutzVersion
            }
          }
        }
      }
      `;

    const context = reactive({
      headers: computed(() => store.state.auth.headers),
    });

    const { execute: updateUserDataPolicy } = useMutation(updateUserDataPolicyMutation, {
      context,
    });

    store.commit('setStrapiExecutionHandler', { item: 'updateUserDataPolicy', result: updateUserDataPolicy });
  },
};
</script>
